(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.compactHeaderEnabled = this.dataset.compactEnabled !== 'false';
      this.compactHeaderTrigger = this.dataset.compactTrigger || 'after_hero';
      this.revealLogoOnScrollUp = this.dataset.revealLogoOnScrollUp !== 'false';
      this.animateCompactHeader = this.dataset.animateCompact !== 'false';
      this.headerBounds = {};
      this.heroCollapsePoint = null;
      this.compactTransitionUntil = 0;
      this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.onResizeHandler = this.onResize.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      window.addEventListener('resize', this.onResizeHandler, { passive: true });

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);
      window.clearTimeout(this.resizeTimer);
      this.headerLayoutAnimation?.cancel();
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onResize() {
      window.clearTimeout(this.resizeTimer);
      this.resizeTimer = window.setTimeout(() => {
        if (!this.header.classList.contains('scrolled-past-header')) {
          this.heroCollapsePoint = null;
        }
      }, 120);
    }

    getCollapsePoint() {
      if (this.heroCollapsePoint !== null) return this.heroCollapsePoint;

      const headerBoundary = Number(this.headerBounds.bottom) || this.header.offsetHeight;
      if (this.compactHeaderTrigger === 'after_header') {
        this.heroCollapsePoint = headerBoundary;
        return this.heroCollapsePoint;
      }

      const hero = document.querySelector('.pth-hero');
      if (!hero) return headerBoundary;

      const heroBottom = window.scrollY + hero.getBoundingClientRect().bottom;
      this.heroCollapsePoint = Math.max(headerBoundary, heroBottom - this.header.offsetHeight);
      return this.heroCollapsePoint;
    }

    setCompactHeader(compact) {
      if (!this.compactHeaderEnabled) compact = false;
      if (this.header.classList.contains('scrolled-past-header') === compact) return;

      const headerContent = this.header.querySelector('.header');
      const startHeight = headerContent?.getBoundingClientRect().height || 0;
      this.header.classList.toggle('scrolled-past-header', compact);
      const endHeight = headerContent?.getBoundingClientRect().height || 0;
      const canAnimate = this.animateCompactHeader
        && headerContent?.animate
        && !this.prefersReducedMotion.matches
        && Math.abs(startHeight - endHeight) >= 1;
      this.compactTransitionUntil = performance.now() + (canAnimate ? 312 : 32);

      if (!canAnimate) {
        this.headerLayoutAnimation?.cancel();
        headerContent?.style.removeProperty('overflow');
        this.headerLayoutAnimation = null;
        return;
      }

      this.headerLayoutAnimation?.cancel();
      headerContent.style.overflow = 'clip';
      const animation = headerContent.animate(
        [{ height: `${startHeight}px` }, { height: `${endHeight}px` }],
        { duration: 280, easing: 'cubic-bezier(0.16, 1, 0.3, 1)' }
      );
      this.headerLayoutAnimation = animation;
      animation.finished
        .catch(() => {})
        .finally(() => {
          if (this.headerLayoutAnimation !== animation) return;
          headerContent.style.removeProperty('overflow');
          this.headerLayoutAnimation = null;
        });
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const collapsePoint = this.getCollapsePoint();

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (performance.now() < this.compactTransitionUntil) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > collapsePoint) {
        this.setCompactHeader(true);
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > collapsePoint) {
        this.setCompactHeader(!this.revealLogoOnScrollUp);
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= collapsePoint) {
        this.setCompactHeader(false);
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["punartha-our-story"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('punartha-story')) {
  customElements.define('punartha-story', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.addEventListener('click', (event) => {
        const link = event.target.closest('[data-story-film]');
        if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const video = link.parentElement.querySelector('video');
        if (!video) return;
        event.preventDefault();
        video.poster = link.querySelector('img')?.currentSrc || '';
        video.src = link.href;
        video.hidden = false;
        link.hidden = true;
        video.focus({ preventScroll: true });
        video.play().catch(() => {});
      });
      this.querySelectorAll('video').forEach(video => {
        video.addEventListener('play', () => {
          this.querySelectorAll('video').forEach(other => { if (other !== video) other.pause(); });
        });
        video.addEventListener('error', () => {
          video.hidden = true;
          const link = video.parentElement.querySelector('[data-story-film]');
          link.hidden = false;
          link.focus({ preventScroll: true });
        });
      });
    }
    disconnectedCallback() { this.querySelectorAll('video').forEach(video => video.pause()); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
